module.exports = __webpack_public_path__ + "static/media/BlackWidow.916ca634.png";